export default "__VITE_ASSET__ee92987a__"